import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const LoyalDonorActions = importer("Stores/Loyalty/Actions");
const { user } = importer("Stores/Users/Select", null);

export default function* success(res) {
  try {
    const _user = yield select(user);
    yield put(LoyalDonorActions.getLoyaltyDetails(_user.pdn))
    yield put(LoyalDonorActions.getLoyaltyActivity(_user.pdn))
  } catch (error) {
    console.log(error)
  }
}